export const GA_EVENTS = {
    WEB_PRICE_DROP_DESKTOP: {
        eventCategory: "price_drop",
        eventAction: "variant_assigned",
        event: "experiment",
        eventLabel: ""
    },
    VIEW_ITEM_LIST: {
        eventCategory: "Ecommerce event",
        eventAction: "price_drop",
        event: "view_item_list",
        eventLabel: ""
    },
    VIEW_ITEM: {
        eventCategory: "Ecommerce event",
        eventAction: "price_drop",
        event: "View_item",
        eventLabel: ""
    },
    FILTER_SELECTED: {
        eventCategory: "Cars24_listing_page",
        eventAction: "filter_selected",
        event: "custom_event",
        eventLabel: "GREAT DEALS"
    },
    FILTER_GREAT_DEALS: {
        eventCategory: "Cars24_listing_page",
        eventAction: "filter_great_deals",
        event: "custom_event",
        eventLabel: ""
    },
    TOP_FILTER_SELECTED: {
        eventCategory: "Cars24_listing_page",
        eventAction: "top_filter_selected",
        event: "custom_event",
        eventLabel: ""
    },
    START_PURCHASE_PRICE_DROP: {
        eventCategory: "Ecommerce event",
        eventAction: "price_drop",
        event: "startPurchase",
        eventLabel: ""
    },
    START_PURCHASE_CAR_TAG: {
        eventCategory: "Ecommerce event",
        eventAction: "car_tag",
        event: "startPurchase",
        eventLabel: ""
    },
    LOCATION_HIGHLIGHING: {
        eventCategory: "location_highlighting",
        eventAction: "variant_assigned",
        event: "experiment"
    },
    FILTER_LOCATION_SELECTED: {
        eventCategory: "Cars24_listing_page",
        eventAction: "filter_selected",
        event: "custom_event",
        eventLabel: "Locations"
    },
    FILTER_LOCATION: {
        eventCategory: "Cars24_listing_page",
        eventAction: "filter_location",
        event: "custom_event",
        eventLabel: ""
    }
};
